import { render, staticRenderFns } from "./bookStackHeader.vue?vue&type=template&id=28585a21&scoped=true"
import script from "./bookStackHeader.vue?vue&type=script&lang=js"
export * from "./bookStackHeader.vue?vue&type=script&lang=js"
import style0 from "./bookStackHeader.vue?vue&type=style&index=0&id=28585a21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28585a21",
  null
  
)

export default component.exports